export {
  BrandResultList
} from '../BrandLandingPage'
